import { HardFailInfo } from "features/map/utils/layerHealthMonitor";
import { WMSOptions } from "leaflet";

import { createWmsLayer } from "lib/leaflet";
import { createMonitoredWMSLayer } from "lib/leaflet/createLayer";

export type WMSoptionsExt = WMSOptions & { token?: string };

const wmsLayerOptionsDefaults: WMSoptionsExt = {
  transparent: true,
  format: "image/png",
  uppercase: true,
  updateWhenIdle: true,   // don’t keep requesting during pan
  updateWhenZooming: false, // don’t keep requesting during zoom
  maxZoom: 20,
};

export const newWMSLayer = (url: string, options: any) => {
  const opt = { ...wmsLayerOptionsDefaults, ...options };
  // We need to ignore typescript error on transparent parameter because datafordeleren implements it as a string
  //@ts-ignore
  return createWmsLayer(url, opt);
};

export const newMonitoredWMSLayer = (
  url: string,
  options: any,
  id: string,
  label: string,
  onLayerEvent: (info: HardFailInfo) => void
) => {
  return createMonitoredWMSLayer(url, {...wmsLayerOptionsDefaults, ...options}, id, label, onLayerEvent);
}
